import imageCompression from "browser-image-compression";

export const compressFile = async (file: File): Promise<string> => {
  const options = {
    maxSizeMB: 1,
    useWebWorker: true,
    maxIteration: 20,
    fileType: "image/jpeg",
  };

  try {
    const compressedFile = await imageCompression(file, options);

    return URL.createObjectURL(compressedFile);
  } catch (error) {
    throw new Error(error.message);
  }
};
